import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguageSelector } from '../components/LanguageSelector';
import { useAuth } from '../auth/AuthContext';
import { useAuthDialog } from '../auth/AuthDialogContext';

export function MenuPage() {
  const { t } = useTranslation(['nav', 'common', 'auth']);
  const { user, logout } = useAuth();
  const { openAuth } = useAuthDialog();

  return (
    <div className="page menu-page">
      <div className="menu-brand-block">
        <strong className="logo-text">
          VBB<span>PLAY</span>
        </strong>
        <LanguageSelector />
      </div>

      <div className="menu-card-grid">
        <article className="menu-info-card">
          <h2>{t('nav:sports')}</h2>
          <Link to="/sports">{t('common:liveSports', { defaultValue: 'Live' })}</Link>
          <Link to="/sports">{t('common:prematch', { defaultValue: 'Prematch' })}</Link>
          <Link to="/games">{t('nav:casino')}</Link>
        </article>
        <article className="menu-info-card">
          <h2>{t('common:infoSection', { defaultValue: 'Information' })}</h2>
          <Link to="/bonuses">{t('nav:bonuses')}</Link>
          <Link to="/vip">VIP</Link>
          <Link to="/referral">{t('common:referral', { defaultValue: 'Referral' })}</Link>
          <Link to="/qaydalar">{t('common:rulesLink')}</Link>
          <Link to="/support">{t('common:footerSupport')}</Link>
        </article>
      </div>

      <article className="menu-support-card">
        <div>
          <h2>
            {t('common:support247', { defaultValue: 'Support 24/7' })}
            <span className="badge-247">24/7</span>
          </h2>
          <p>{t('common:supportInvite', { defaultValue: 'Our operators are ready to help.' })}</p>
        </div>
        <Link to="/support" className="btn btn-primary btn-block">
          {t('common:contactSupport', { defaultValue: 'Contact support' })}
        </Link>
      </article>

      <div className="menu-card-grid">
        <article className="menu-info-card">
          <h2>{t('common:storyCrypto')}</h2>
          <p className="muted-note">{t('common:cryptoMethodsHint', { defaultValue: 'Crypto deposit methods in Cashier' })}</p>
          <Link to="/cashier?tab=deposit">{t('nav:wallet')}</Link>
        </article>
        <article className="menu-info-card">
          <h2>{t('common:fiatMethods', { defaultValue: 'Fiat' })}</h2>
          <p className="muted-note">{t('common:fiatMethodsHint', { defaultValue: 'Card, M10, Terminal' })}</p>
          <Link to="/cashier?tab=deposit">{t('nav:wallet')}</Link>
        </article>
      </div>

      <div className="menu-list">
        {user ? (
          <>
            <Link to="/profile" className="menu-row">
              {t('nav:profile')}
              <span className="chevron">›</span>
            </Link>
            <Link to="/settings" className="menu-row">
              {t('common:myProfile', { defaultValue: 'Settings' })}
              <span className="chevron">›</span>
            </Link>
            <Link to="/notifications" className="menu-row">
              {t('common:notificationsTitle', { defaultValue: 'Notifications' })}
              <span className="chevron">›</span>
            </Link>
            <button type="button" className="menu-row" onClick={() => void logout()}>
              {t('auth:logout', { defaultValue: 'Log out' })}
            </button>
          </>
        ) : (
          <>
            <Link
              to="/auth/login"
              className="menu-row"
              onClick={(event) => {
                event.preventDefault();
                openAuth('login');
              }}
            >
              {t('nav:login')}
              <span className="chevron">›</span>
            </Link>
            <Link
              to="/auth/register"
              className="menu-row"
              onClick={(event) => {
                event.preventDefault();
                openAuth('register');
              }}
            >
              {t('auth:registerCta')}
              <span className="chevron">›</span>
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
